;(function () {
  /**
   * Validates phone number format
   *
   * @param {string} phone - Phone number to validate
   * @returns {boolean} - True if valid (4-15 digits), false otherwise
   */
  function validatePhone(phone) {
    if (!phone || typeof phone !== "string") {
      return false
    }

    // Remove all non-digit characters
    const digitsOnly = phone.replace(/\D/g, "")

    // Check if length is between 4 and 15 digits
    return digitsOnly.length >= 4 && digitsOnly.length <= 15
  }

  // Export to global namespace
  window.HB = window.HB || {}
  window.HB.validatePhone = validatePhone
})()
